'use strict';

var util = require('../../util/property-util');
var messageDiscriptors = require('../../util/messageDiscriptors');

module.exports = /*@ngInject*/ ["$rootScope","$scope", "$q", "$timeout", "CoverageMapAnalysisFactory", "trainData", "KmlExportFactory", "MessageDataStructure", "MessageDataRepository", "MessageDataFilter", "MessageDataStructureStorage", "GoogleMapsFactory", "ProjectService", "UrlRoutingFactory", "boxDiscriminationInfo", "$filter", "LocaleFactory", function ($rootScope, $scope, $q, $timeout, CoverageMapAnalysisFactory, trainData, KmlExportFactory, MessageDataStructure, MessageDataRepository, MessageDataFilter, MessageDataStructureStorage, GoogleMapsFactory, ProjectService, UrlRoutingFactory, boxDiscriminationInfo, $filter, LocaleFactory) {
    var cm = this;
    cm.parent = $scope.$parent.base;
    var name = 'coverage-map';
    var polylines = [];
    var cachedData = undefined;

    var previousState = {
        messageName: undefined,
        discriminator: undefined,
        subDiscriminator: undefined
    };
    var previousProperty = undefined;
    var poller = {};
    var pollerPromise = undefined;
    var hoverMarker = undefined;

    var previousDataPoint = undefined;

    var init = function () {
        "use strict";
        var own = cm.parent.getChildByName(name);
        own.loaded.deferred.resolve();
        cm.trainData = trainData;
        cm.showPanel = false;
        cm.projectId = ProjectService.getSelectedProjectId();

        // this is the messageStructure that represents the state of the messageStructure when pressing the apply button
        cm.messageStructure = new MessageDataStructure(boxDiscriminationInfo);
        // this is the messageStructure that represents the current state of the panel
        cm.viewStructure = new MessageDataStructure(boxDiscriminationInfo);

        cm.map = undefined;
        previousState = cm.messageStructure.getCurrentState();
        cm.legend = [];
        cm.foundBoundaries = {};
        cm.newInstance = true;
        cm.loading = false;
        cm.isEmpty = false;
        cm.propertySelected = false;
        cm.options = {
            filter: false,
            logscale: false,
            reloadData: true,
            reverseColors: false,
            minimum: 0,
            maximum: 100,
            intervals: 5,
            selectedVu: 'All',
            live: false,
            follow: false,
            interpolate: false,
            interpolateSeconds: 15,
            intervalTime: 15
        };
        cm.viewOptions = angular.copy(cm.options);

        loadOptionsFromUrl();

        // since we might just be switching train/trip try to load the saved messageDataStructure
        var storedMessageDataStructure = MessageDataStructureStorage.get(name);
        if (util.isDefined(storedMessageDataStructure)) {
            cm.messageStructure = storedMessageDataStructure;
            cm.viewStructure = storedMessageDataStructure;
            if (util.isDefined(cm.messageStructure.getCurrentState().messageName)) {
                cm.showPanel = true;
            }
            createCoverageMap();
        }
    };

    $scope.$on('activate-' + name, function () {
        "use strict";
        if (!util.isDefined(cm.map)) {
            resetMap();
        }
    });

    $scope.$on('de-activate-' + name, function () {
        "use strict";
    });

    $scope.$on('apply', function () {
        "use strict";
        cm.newInstance = false;
        createCoverageMap();
    });

    $rootScope.$on("languageChanged", () =>  {
        "use strict";
        var contentString = CoverageMapAnalysisFactory.createEmptyContentString();

        $('#hoverValue').html(contentString);
    });


    /**
     * This function export the current drawn polylines to kml format
     */
    $scope.$on('exportKml', function () {
        var checkedProperty = getCurrentCheckedProperty();

        if (util.isEmpty(checkedProperty)) {
            cm.viewStructure.enableApply = false;
            return;
        } else {
            cm.viewStructure.enableApply = true;
        }

        var options = getOptions(checkedProperty);
        KmlExportFactory.export(polylines, options, trainData);
    });

    /**
     * Returns the checked property
     *  Since the coverage map panel can only have 1 currently selected property (radiobuttons)
     *  We can assume the list from the messageStructure returns a list that only contains 1 item
     */
    var getCurrentCheckedProperty = function () {
        return cm.messageStructure.getCurrentSingleCheckedProperties(cm.messageStructure.getCurrentState().messageName, cm.messageStructure.getCurrentState().discriminator, cm.messageStructure.getCurrentState().subDiscriminator)
    };

    /**
     * Main function to draw the polylines on the map
     *  - we remove the existing polylines, we'll redraw everything
     *  - we save the current filter options to the URL
     *  - we don't always have to fetch data:
     *      - re-use existing cached data when only changing options
     *          - just redraw the data with the changed options
     *      - in all other scenario's we either fetch new data or rely on the MessageStructureRepository's cache
     *          - we re-merge the new data
     *          - we draw the data on the map
     *          - we create the legend and start the poller (if wanted)
     *  - save the current messageStructure (this might be used when switching trip/train)
     *  - keep track of the checkedProperty and previousState
     */
    var createCoverageMap = function () {
        cm.loading = true;
        // since we're working with a decoupled messageStructure between internal calculations and the view, we need to 'copy' the view's messageStructure
        cm.messageStructure.setData(cm.viewStructure.getData());
        cm.messageStructure.setCurrentState(cm.viewStructure.getCurrentState());
        cm.options = angular.copy(cm.viewOptions);

        GoogleMapsFactory.removeObjectsFromMap(polylines);
        // determine the needed actions
        var checkedProperty = getCurrentCheckedProperty();
        if (util.isEmpty(checkedProperty)) {
            cm.loading = false;
            cm.viewStructure.enableApply = false;
            return;
        } else {
            cm.viewStructure.enableApply = true;
        }
        // inject properties of the selected property into the options object
        var options = getOptions(checkedProperty);
        saveOptionsToUrl(options);
        //todo check if obj can be compared
        if (previousState != cm.messageStructure.getCurrentState()
            || previousProperty != checkedProperty
            || !util.isDefined(cachedData)
            || options.reloadData
            || cm.messageStructure.getCurrentState().messageName == "virtualUser" && util.isDefined(options.selectedVu)) {
            dataStorage.clear();
            // something changed, we need other data
            var dataPromise = getCoverageMapData(cm.messageStructure.getCurrentState().messageName, checkedProperty, cm.trainData, options, previousDataPoint, MessageDataRepository.getMessageData);
            dataPromise.then(function (data) {
                var colors = CoverageMapAnalysisFactory.generateColors(options.minimum, options.maximum, options.intervals, options.reverseColors, options.logscale);
                polylines = drawDataOnMap(data, cm.map, options, colors, true);
                addHoverListeners(polylines, options);
                cm.isEmpty = polylines.length == 0;

                createLegend(data, options, colors);
                // if the live options is selected, start the poller
                if (options.live) {
                    poller.pollData();
                }

                if (data.length > 0) {
                    previousDataPoint = data[data.length - 1];
                    CoverageMapAnalysisFactory.fitDataPointsOnMap(data, cm.map);
                }
            });
        } else {
            var colors = CoverageMapAnalysisFactory.generateColors(options.minimum, options.maximum, options.intervals, options.reverseColors, options.logscale);
            // just the options changed, use the cached data to redraw
            drawDataOnMap(cachedData, cm.map, options, colors, false);
            createLegend(cachedData, options, colors);
            if (options.live) {
                poller.pollData();
            }
        }
        MessageDataStructureStorage.save(name, cm.messageStructure);
        previousProperty = checkedProperty;
        previousState = cm.messageStructure.getCurrentState();
    };

    var addHoverListeners = function (polylines, options) {
        //todo: cleanup
        polylines.forEach(function (polyline) {
            google.maps.event.addListener(polyline, 'mouseover', function () {
                var formattedValue = options.formatFunction(polyline.value, options.unit);

                if (!isNaN(new Number(formattedValue))) {
                    formattedValue = $filter('number')(formattedValue, 2);
                }

                var contentString = CoverageMapAnalysisFactory.createContentString(formattedValue, polyline.timestamp, options.label);

                console.log(contentString)
                $('#hoverValue').html(contentString);
                var startWaypoint = polyline.getPath().getAt(0);
                var endWaypoint = polyline.getPath().getAt(1);
                if (!util.isDefined(endWaypoint)) {
                    endWaypoint = startWaypoint;
                }
                var pos = new google.maps.LatLng((startWaypoint.lat() + endWaypoint.lat()) / 2, (startWaypoint.lng() + endWaypoint.lng()) / 2);

                hoverMarker.setPosition(pos);
            });
        });
    };

    /**
     * Resets various options for the coverageMapAnalysisController
     * Also creates a google maps map if cm.map is not defined yet
     */
    var resetMap = function () {
        cm.loading = false;
        cm.legend = undefined;
        //create google maps object
        if (!util.isDefined(cm.map)) {
            var map = GoogleMapsFactory.createMap('coverageMap');
            map.then(function (data) {
                cm.map = data;
                $timeout(function () {
                    google.maps.event.trigger(cm.map, 'resize');
                    hoverMarker = new google.maps.Marker({
                        map: cm.map
                    });
                    var contentString = CoverageMapAnalysisFactory.createEmptyContentString();

                    $('#hoverValue').html(contentString);
                });
            });
        }
    };

    cm.setMessageName = function (messageName) {
        "use strict";
        cm.viewStructure.setInitialState(messageName);
        cm.showPanel = true;
    };

    /**
     * This function takes minimum and maximum values found in the data (cm.foundBoundaries)
     * and applies this to the filter panel (that uses cm.options)
     */
    cm.applyMinMaxToFilter = function () {
        var getNumericForBoolean = function (value) {
            if (typeof value == "boolean") {
                return value == true ? 1 : 0;
            } else {
                return value;
            }
        };
        if (util.isDefined(cm.foundBoundaries.min) && util.isDefined(cm.foundBoundaries.max)) {
            //todo: this must be applied to the directive
            cm.viewOptions.minimum = getNumericForBoolean(cm.foundBoundaries.min);
            cm.viewOptions.maximum = getNumericForBoolean(cm.foundBoundaries.max);
        }

        //re apply
        cm.newInstance = false;
        createCoverageMap();

    };

    /**
     * Draws data on the google map,
     * @param data the actual data that needs to be drawn on the map (needs timestamp, gps coordinates and a value)
     * @param map google.maps.Map object
     * @param options the options that the polylines need to take into account
     * @param colors is an array of color objects
     * @param zoom  {boolean} should we fit to bounds?
     * @returns {polylines} an array of polylines that were drawn on the map
     */
    var drawDataOnMap = function (data, map, options, colors, zoom) {
        var plotInformation = CoverageMapAnalysisFactory.plotData(cm.map, options, data, colors, options.formatFunction);
        setFoundDataBoundaries(plotInformation.foundBoundaries.min, plotInformation.foundBoundaries.max, options.formatFunction, options.unit, false);
        if (util.isDefined(zoom) && zoom && util.isDefined(data) && data.length > 1) {
            CoverageMapAnalysisFactory.fitDataPointsOnMap(data, cm.map);
        }
        cm.loading = false;
        return plotInformation.polylines;
    };

    var setFoundDataBoundaries = function (min, max, formatFunction, unit, update) {
        if (update && util.isDefined(cm.foundBoundaries.min) && util.isDefined(cm.foundBoundaries.max)) {
            if (min < cm.foundBoundaries.min) {
                cm.foundBoundaries.min = min;
                cm.foundBoundaries.formattedMinimum = util.isDefined(formatFunction)? formatFunction(min, unit): undefined;
            }
            if (max > cm.foundBoundaries.max) {
                cm.foundBoundaries.max = max;
                cm.foundBoundaries.formattedMaximum = util.isDefined(formatFunction)? formatFunction(max, unit): undefined;
            }
        } else {
            cm.foundBoundaries = {
                min: min,
                max: max,
                formattedMinimum: util.isDefined(formatFunction) ? formatFunction(min, unit) : undefined,
                formattedMaximum: util.isDefined(formatFunction) ? formatFunction(max, unit) : undefined
            };
        }
    };

    /**
     * Creates the legend
     * @param data the merged gps-message data
     * @param options filter options
     * @param colors array of colors
     */
    var createLegend = function (data, options, colors) {
        var legendItems;
        cm.staticLegend = options.staticLegend;

        if (!util.isDefined(options.formatFunction)) {
            cm.legend = [];
            return;
        }

        if (cm.staticLegend) {
            // create static legend
            legendItems = CoverageMapAnalysisFactory.generateStaticLegendItems(data, options.formatFunction);
        } else {
            legendItems = CoverageMapAnalysisFactory.generateLegendItems(colors, options.formatFunction, options.unit);
        }
        cm.legend = legendItems;
    };

    /**
     * This function takes a property (which contains a name) and an object
     * we create a plain json object that contains a timestamp and the value of the property in the object
     * @param property  the property of that describes the value that we want out of the object
     * @param object    the object that contains the property
     * @returns {{timestamp: Date, value: undefined}}
     */
    var createValueTimeObject = function (property, object) {
        var propertyValue = undefined;
        if (property && property.axis && property.axis.toLowerCase().search("boolean") > 0) {
            if (propertyValue) {
                propertyValue = 1;
            } else {
                propertyValue = 0;
            }
        } else {
            propertyValue = property && object[property.name];
        }
        return {timestamp: new Date(object['timestamp']), value: propertyValue};

    };

    /**
     * Handles the fetching, merging of message and gps data
     * We first fetch both the message and gps data (either live or regular - defined by fetchFunction)
     *
     * Because gps data and message data are not always synchronized, we must keep track of what we've plotted so far, and what we haven't
     *      To do this we use the dataStorage: we look for the latest message that could be mapped onto gps coordinates.. the timestamp of that message is the 'lastMatchedTimestamp'
     *      Data (for both msg and gps) that is after or equal to this timestamp is stored in the dataStorage
     *      Data that is before or equal is returned (we return the merged data: 'mergedDataBeforeTimestamp')
     *      You might have noticed there is an overlap of timestamps (1 exactly) between the stored and the returned, this is because a polyline always needs to be between 2 points,
     *      so on the next iteration we need that previous point.
     *
     * Data is filtered by selected property (filterData, filterPropertiesForEntry)
     * A map (timestamp - object) for both gps and messageData is created, these 2 maps are then merged together.
     * As result of this merging we get an array of object that contain a timestamp, a value (if not found: -1) and gps coordinates
     * @param messageName   The messsagename for which'll fetch data
     * @param property      The selected property
     * @param trainData     TrainData, contains from and to timestamp, trainId, projectId, etc.
     * @param fetchFunction This function determines the method of fetching data (should be either 'getMessageData' or 'getLiveMessageData')
     * @returns {*}     The merged data that needs to be drawn
     */
    var getCoverageMapData = function (messageName, property, trainData, options, previousData, fetchFunction) {
        "use strict";
        // fetchFunction will either be getMessageData or getLiveMessageData
        var messageDataPromise = fetchFunction(messageName, trainData.relativeTrainId, trainData.projectId, trainData.from, trainData.to, cm.messageStructure.getRate(messageName));
        var gpsDataPromise = fetchFunction(getGpsMessageName(messageName), trainData.relativeTrainId, trainData.projectId, trainData.from, trainData.to, cm.messageStructure.getRate(messageName));

        return $q.all([messageDataPromise, gpsDataPromise]).then(function (data) {
            // concat the stored data
            data[0] = dataStorage.getStoredMessageData().concat(data[0]);
            data[1] = dataStorage.getStoredGpsData().concat(data[1]);

            // only data for the current discriminator/sub-discriminator is kept
            var filtered = MessageDataFilter.filterDataOnCurrent(data[0], cm.messageStructure);
            // do we actually have data?
            if (filtered.length > 0) {
                // extract the checked property
                var entryProperties = MessageDataFilter.filterPropertiesForEntry([property], filtered[0], messageName, cm.messageStructure);
                if (messageName === "virtualUser" && util.isDefined(cm.options.selectedVu)) {
                    filtered = CoverageMapAnalysisFactory.filterVuSite(filtered, cm.options.selectedVu);
                }
                // create timestamp - (timestamp, value) map
                var messageDataValueMap = CoverageMapAnalysisFactory.createTimestampMap(filtered, entryProperties[0], createValueTimeObject);
                var gpsDataMap = CoverageMapAnalysisFactory.createTimestampMap(data[1], entryProperties[0]);

                // merge the two timestamp maps
                var mergedData = undefined;
                if (cm.options.interpolate) {
                    mergedData = CoverageMapAnalysisFactory.interpolatDataMaps(gpsDataMap, messageDataValueMap, cm.options.interpolateSeconds, cm.options.live ? previousData : undefined);
                } else {
                    mergedData = CoverageMapAnalysisFactory.mergeDataMaps(gpsDataMap, messageDataValueMap);
                }
                var lastMatchedTimestamp = CoverageMapAnalysisFactory.getLastMatchedTimestamp(mergedData);
                // store everything after the last matched timestamp
                // if the last mactched timestamp isn't defined, we store everything
                dataStorage.storeMessageData(data[0], lastMatchedTimestamp);
                dataStorage.storeGpsData(data[1], lastMatchedTimestamp);
                // there was an actual match, we should only return data up until that last matched timestamp
                if (util.isDefined(lastMatchedTimestamp)) {
                    var mergedDataBeforeTimestamp = getMergedDataBeforeTimestamp(mergedData, lastMatchedTimestamp);
                    cachedData = mergedDataBeforeTimestamp;
                    mergedDataBeforeTimestamp.sort(function (a, b) {
                        return a.timestamp - b.timestamp;
                    });
                    return mergedDataBeforeTimestamp;
                } else {
                    cachedData = [];
                    // there was no match, all data is stored in the data storage.. let's return an empty array
                    return [];
                }
            } else {
                // even though we couldn't find a message, we still might need this gps data in next iteration
                dataStorage.storeGpsData(data[1]);
                return [];
            }
        });
    };

    /**
     * Returns an array of object of which the timestamp property is equal or lower than the provided timestamp
     * @param data          array of json object (must have timestamp property)
     * @param timestamp     timestamp to compare the objects to
     * @returns {Array}
     */
    var getMergedDataBeforeTimestamp = function (data, timestamp) {
        var before = [];
        data.some(function (entry) {
            if (entry.timestamp <= timestamp) {
                before.push(entry);
                return false;
            } else {
                return true;
            }
        });
        return before;
    };

    /**
     * Stores message and gps data that might need to be used in the next cycle
     */
    var dataStorage = {
        messageData: [],
        gpsData: [],
        // we store >= because the drawing of the polyline needs 2 coordinates, otherwise we would create a gap
        getDataAfterTimestamp: function (data, timestamp) {
            var after = [];
            for (var i = 0; i < data.length; i++) {
                var entry = data[i];
                if (entry.timestamp >= timestamp) {
                    after.push(entry);
                }
            }
            return after;
        },
        storeMessageData: function (data, timestamp) {
            if (util.isDefined(timestamp)) {
                this.messageData = this.getDataAfterTimestamp(data, timestamp);
            } else {
                this.messageData = data;
            }
        },
        storeGpsData: function (data, timestamp) {
            if (util.isDefined(timestamp)) {
                this.gpsData = this.getDataAfterTimestamp(data, timestamp);
            } else {
                this.gpsData = data;
            }
        },
        getStoredMessageData: function () {
            return this.messageData;
        },
        getStoredGpsData: function () {
            return this.gpsData;
        },
        clear: function () {
            this.gpsData = [];
            this.messageData = [];
        }
    };

    /**
     * Returns the messagename for the GPS repository for a particular messagename
     * @param name
     * @returns {*}
     */
    var getGpsMessageName = function (name) {
        return "gpsData";
    };

    /**
     * handles the fetching and drawing of live data
     */
    var liveCoverageMap = function () {
        // determine the needed actions
        var property = getCurrentCheckedProperty();
        if (util.isEmpty(property)) {
            cm.viewStructure.enableApply = false;
            return;
        } else {
            cm.viewStructure.enableApply = true;
        }

        var options = getOptions(property);
        var messageName = cm.messageStructure.getCurrentState().messageName;

        var dataPromise = getCoverageMapData(messageName, property, trainData, options, previousDataPoint, MessageDataRepository.getLiveMessageData);
        dataPromise.then(function (data) {
            var colors = CoverageMapAnalysisFactory.generateColors(options.minimum, options.maximum, options.intervals, options.reverseColors, options.logscale);
            var plotInformation = CoverageMapAnalysisFactory.plotData(cm.map, options, data, colors, options.formatFunction);
            setFoundDataBoundaries(plotInformation.foundBoundaries.min, plotInformation.foundBoundaries.max, options.formatFunction, options.unit, true);

            addHoverListeners(plotInformation.polylines, options);
            polylines = polylines.concat(plotInformation.polylines);
            cm.isEmpty = polylines.length === 0;
            if (options.live) {
                poller.pollData();
                if (options.follow) {
                    var coordinates = polylines[polylines.length - 1].getPath();
                    var tmp = [];
                    coordinates.forEach(function (coord) {
                        tmp.push(coord);
                    });
                    cm.map.panTo(tmp[0]);
                }
            }

            if (data.length > 0) {
                previousDataPoint = data[data.length - 1];
            }
        });
    };
    /**
     * Since we want to be able to change the live properties when running liveview (eg. toggle follow)
     * but the options in the view are decoupled from those used in this controller so we copy the properties that matter to the liveView
     */
    var updateOptionsForLiveView = function () {
        // only change liveview when toggling to false, not when toggling to true
        cm.options.live = !cm.viewOptions.live ? false : cm.options.live;
        cm.options.follow = cm.viewOptions.follow;
        cm.options.intervalTime = cm.viewOptions.intervalTime;
    };

    /**
     * Loads filter options from the url and applies them to corresponding variables
     */
    var loadOptionsFromUrl = function () {
        var parseStringToBoolean = function (string) {
            if (string == true || string == "true") {
                return true;
            } else if (string == false || string == "false") {
                return false;
            }
        };
        // let's just assume that all are set when minimum is set
        if (!util.isDefined(UrlRoutingFactory.get("minimum"))) {
            return;
        }
        cm.viewOptions.minimum = Number(UrlRoutingFactory.get("minimum"));
        cm.viewOptions.maximum = Number(UrlRoutingFactory.get("maximum"));
        cm.viewOptions.intervals = Number(UrlRoutingFactory.get("intervals"));
        cm.viewOptions.reverseColors = parseStringToBoolean(UrlRoutingFactory.get("reverseColors"));
        cm.viewOptions.logscale = parseStringToBoolean(UrlRoutingFactory.get("logscale"));
        cm.viewOptions.filter = parseStringToBoolean(UrlRoutingFactory.get("filter"));
        cm.viewOptions.reloadData = parseStringToBoolean(UrlRoutingFactory.get("reload"));
        cm.viewOptions.interpolate = parseStringToBoolean(UrlRoutingFactory.get("interpolate"));
        var seconds = Number(UrlRoutingFactory.get("interpolateSeconds"));
        cm.viewOptions.interpolateSeconds = !isNaN(seconds) ? seconds : 15;
        if (!trainData.isTrip) {
            cm.viewOptions.live = parseStringToBoolean(UrlRoutingFactory.get("live"));
            cm.viewOptions.follow = parseStringToBoolean(UrlRoutingFactory.get("follow"));
            cm.viewOptions.intervalTime = Number(UrlRoutingFactory.get("intervalTime"));
        }
    };

    /**
     * Saves the filter options to the URL
     * @param options
     */
    var saveOptionsToUrl = function (options) {
        UrlRoutingFactory.save("minimum", options.minimum);
        UrlRoutingFactory.save("maximum", options.maximum);
        UrlRoutingFactory.save("intervals", options.intervals);
        UrlRoutingFactory.save("reverseColors", options.reverseColors);
        UrlRoutingFactory.save("filter", options.filter);
        UrlRoutingFactory.save("logscale", options.logscale);
        UrlRoutingFactory.save("reload", options.reloadData);
        UrlRoutingFactory.save("interpolate", options.interpolate);
        UrlRoutingFactory.save("interpolateSeconds", options.interpolateSeconds);
        if (!trainData.isTrip) {
            UrlRoutingFactory.save("live", options.live);
            UrlRoutingFactory.save("follow", options.follow);
            UrlRoutingFactory.save("intervalTime", options.intervalTime);
        }
    };

    /**
     * returns the options object
     * we inject the properties of the provided property into the options object
     * @param property
     * @returns the options object
     */
    var getOptions = function (property) {
        updateOptionsForLiveView();
        var options = cm.options;
        if (property) {
            options.label = property.label;
            options.unit = property.unit;
            options.staticLegend = property.staticLegend;
            var metaInfo = messageDiscriptors.getAxisMetaByType(property.axis);
            options.formatFunction = metaInfo ? metaInfo.formatFunction : undefined;
        }
        options.logscale = options.minimum > 0 ? options.logscale : false;
        return options;
    };

    poller.pollData = function () {
        this.stopPoller();
        pollerPromise = $timeout(liveCoverageMap, cm.options.intervalTime * 1000);
    };

    poller.stopPoller = function () {
        if (util.isDefined(pollerPromise)) {
            $timeout.cancel(pollerPromise);
        }
    };

    $scope.$on('$destroy', function () {
        poller.stopPoller();
    });

    init();
}];